import { EXCLUDE_COUNTRIES } from "../../../common/constants";
import { CountryItem } from "../../../redux/types";

export const getFilteredCountries = (countries: CountryItem[]) =>
  countries.filter(({ code }) => !EXCLUDE_COUNTRIES.includes(code.toUpperCase()));
